Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var title_component = require('../title/component.js');
var common_module = require('../common.module-0ac16ac5.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var styles = {"styrene-xlarge":"typography__styrene-xlarge_c57sk","styrene-large":"typography__styrene-large_c57sk","styrene-medium":"typography__styrene-medium_c57sk","styrene-small":"typography__styrene-small_c57sk","styrene-xsmall":"typography__styrene-xsmall_c57sk","system-xlarge":"typography__system-xlarge_c57sk","system-large":"typography__system-large_c57sk","system-medium":"typography__system-medium_c57sk","system-small":"typography__system-small_c57sk","system-xsmall":"typography__system-xsmall_c57sk","margins-xlarge":"typography__margins-xlarge_c57sk","margins-large":"typography__margins-large_c57sk","margins-medium":"typography__margins-medium_c57sk","margins-small":"typography__margins-small_c57sk","margins-xsmall":"typography__margins-xsmall_c57sk"};
require('./index.css');

var TitleMobile = React.forwardRef(function (props, ref) { return (React__default.default.createElement(title_component.TitleBase, tslib.__assign({}, props, { styles: Object.assign(common_module.commonStyles, styles), ref: ref, platform: 'mobile' }))); });

exports.TitleMobile = TitleMobile;
